$(document).ready(function () {

  // var baseUrl = 'https://gtdc1ap001.eastus.cloudapp.azure.com';
    var baseUrl = 'https://shopify-gateway.tronair.com';

  $('#osm-search-btn').click(function () 
  {
    var inputValue = $('#osm-search-input').val();
    if(!!inputValue) 
    {
      $.ajax({
        url: baseUrl + '/shopify/searchosm',
        type: 'GET',
        data: { input: inputValue },
        success: function (response) 
        {
          let html = "";
          console.log('Success:', response);

          for (let item in response)
          {
            item = response[item];

            html += `<h5>${item.itemNumber}</h5>`;
            html += `<h6>${item.description}</h6>`;
            html += `<p>Operation and Service Manuals : ${item.primaryHit}<p>`
            if (item.documents.length > 0)
            {
              html += '<p>Additional Revisions:<ul>'
              for(var i in item.documents)
                {
                  i = item.documents[i];
                  html += `<li>${i}</li>`;
                }
              html += '</ul>';
            }
          }

          if (html.length > 0)
          {
            $('.direct-match').html(html);
          }
          else
          {
            $('.direct-match').html("No match found for your entry, try changing your search request or email sales@tronair.com for assistance.");
          }

          $('.direct-match').show();
        },
        error: function (xhr, status, error) 
        {
          console.error('Error:', error);
          $('.direct-match').html("No match found for your entry, try changing your search request or email sales@tronair.com for assistance.");
          $('.direct-match').show();
        }
      });
    }

  });

  const urlParams = new URLSearchParams(window.location.search);
  const query = urlParams.get('query')
  const noSpares = urlParams.get('noSpares')
  if(!!query) {
    $('#osm-search-input').val(query)
    $('#osm-search-btn').click()
  }
  if (!!noSpares) {
    const alert = document.createElement('p');
    alert.innerHTML = '<strong>No spares found, please search for an Operation Service Manual for support.</strong>';
    alert.style.textAlign = 'center';
    document.querySelector('.osm-search-container').firstElementChild.insertAdjacentElement('beforebegin', alert);
  }

});
